import { createStyles } from "@mantine/emotion";

export const useStylesProfilePassword = createStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: theme.flex.justify.center,
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      justifyContent: theme.flex.justify.start,
    },
  },
  label: {
    paddingRight: theme.spacing.profile.padding.right,
    fontFamily: theme.headings.fontFamily.bold,
    fontSize: theme.spacing.profile.fontSize.label,
    width: theme.spacing.profile.width.label,
    textAlign: "right",
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      textAlign: "left",
    },
  },
  input: {
    paddingRight: theme.spacing.profile.padding.right,
    border: "1px solid rgba(112, 112, 112, 0.5019607843)",
    fontSize: theme.spacing.profile.fontSize.input,
    lineHeight: theme.spacing.profile.lineHeight.input,
    maxWidth: "100%",
    width: theme.spacing.profile.width.input,
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      width: "100%",
    },
  },
  wrapper: {
    width: "auto",
    [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
      width: "100%",
    },
  },
  wrap: {
    button: {
      top: "0",
    },
  },
}));
